export interface IReferenceDataState {
  isLoading: boolean;
  data: IReferenceDataTypes;
  addNewDialogErrorMessage?: string;
  banks: IBanksData;
  dataTable: {
    pagination: {
      descending?: boolean;
      page?: number;
      rowsPerPage?: number; // -1 for All"
      sortBy?: string;
      totalItems?: number;
    };
  };
}

export interface IReferenceDataTypes {
  [type: string]: IReferenceData;
}

export interface IReferenceData {
  id: number;
  type: ReferenceDataType;
  items: IReferenceDataItem[];
  defaultValue: string;
}

export interface IReferenceDataItem {
  id: number;
  code: string;
  description: string;
}

export enum ReferenceDataType {
  ApplicationType = 1,
  CustomerType = 2,
  ClassOfBuyer = 3,
  PricingProfile = 4,
  RebateProfile = 5,
  BillingPlan = 6,
  AccountFeeProfile = 7,
  CardFeeProfile = 8,
  SalesRepresentative = 9,
  CollectionManager = 10
}

export interface IBanksData {
  [type: string]: IBankDataItem;
}

export interface IBankDataItem {
  bankId: number;
  name: string;
}
